import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import  config from '../../config/config';

export function EditSubcategory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [animalType, setAnimalType] = useState([]);
  const [formData, setFormData] = useState({
    animalType: "",
    name: "",
    Price: "",
    Day1Limit: "",
    Day2Limit: "",
    Day3Limit: "",
    WeightLimit: "",
    DeductionRate: ""
  });

  const [errors, setErrors] = useState({
    animalType: "",
    name: "",
    Price: "",
    Day1Limit: "",
    Day2Limit: "",
    Day3Limit: "",
    WeightLimit: "",
    DeductionRate: ""
  });

  useEffect(() => {
    const fetchAnimalTypes = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${config.baseUrl}/api/subcategories/animal-type`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error('Failed to fetch animal types');
        }
        const data = await response.json();
        setAnimalType(data);
      } catch (error) {
        console.error("Failed to fetch animal types", error);
        setAnimalType([]);
      }
    };

    const fetchSubcategoryData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${config.baseUrl}/api/subcategories/getSubCatById/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        
        if (data.sub_cat) {
          setFormData({
            animalType: data.sub_cat.category_id,
            name: data.sub_cat.name,
            Price: data.sub_cat.price,
            Day1Limit: data.sub_cat.day1_limit,
            Day2Limit: data.sub_cat.day2_limit,
            Day3Limit: data.sub_cat.day3_limit,
            WeightLimit: data.sub_cat.weight_limit,
            DeductionRate: data.sub_cat.deduction_rate
          });
        }
      } catch (error) {
        console.error("Failed to fetch subcategory data", error);
      }
    };

    fetchAnimalTypes();
    fetchSubcategoryData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.animalType) {
      newErrors.animalType = "Animal type is required.";
      isValid = false;
    }

    if (!formData.name) {
      newErrors.name = "Sub Category name is required.";
      isValid = false;
    }

    if (!formData.Price) {
      newErrors.Price = "Price is required.";
      isValid = false;
    }

    if (!formData.WeightLimit || formData.WeightLimit <= 0) {
      newErrors.WeightLimit = "Weight Limit must be greater than 0.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${config.baseUrl}/api/subcategories/updatesubcat/${id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error('Failed to update subcategory');
        }

        alert("Subcategory updated successfully");
        navigate("/subcategories/view");
      } catch (error) {
        console.error("Error updating subcategory:", error);
        alert("Failed to update subcategory. Please try again.");
      }
    }
  };

  return (
    <>
      <div className="">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-bold mb-6">Edit Sub Category</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Type of Animal</label>
                
                <select
                    name="animalType"
                    value={formData.animalType}
                    onChange={handleInputChange}
                    className="w-full border rounded p-2"
                >
                    <option value="">Select Animal Type</option>
                    {animalType.map((type) => (
                        <option key={type.id} value={type.id}>
                            {type.cat_name}  {/* Changed from Cat_name to cat_name */}
                        </option>
                    ))}
                </select>
                {errors.animalType && (
                  <div className="text-red-500 text-sm mt-1">{errors.animalType}</div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Sub Category Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full border rounded p-2"
                  placeholder="Enter sub category name"
                />
                {errors.name && (
                  <div className="text-red-500 text-sm mt-1">{errors.name}</div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Price</label>
                <input
                  type="number"
                  name="Price"
                  value={formData.Price}
                  onChange={handleInputChange}
                  className="w-full border rounded p-2"
                  placeholder="Enter price"
                />
                {errors.Price && (
                  <div className="text-red-500 text-sm mt-1">{errors.Price}</div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Day 1 Limit</label>
                <input
                  type="number"
                  name="Day1Limit"
                  value={formData.Day1Limit}
                  onChange={handleInputChange}
                  className="w-full border rounded p-2"
                  placeholder="Enter day 1 limit"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Day 2 Limit</label>
                <input
                  type="number"
                  name="Day2Limit"
                  value={formData.Day2Limit}
                  onChange={handleInputChange}
                  className="w-full border rounded p-2"
                  placeholder="Enter day 2 limit"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Day 3 Limit</label>
                <input
                  type="number"
                  name="Day3Limit"
                  value={formData.Day3Limit}
                  onChange={handleInputChange}
                  className="w-full border rounded p-2"
                  placeholder="Enter day 3 limit"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Weight Limit</label>
                <input
                  type="number"
                  name="WeightLimit"
                  value={formData.WeightLimit}
                  onChange={handleInputChange}
                  className="w-full border rounded p-2"
                  placeholder="Enter weight limit"
                />
                {errors.WeightLimit && (
                  <div className="text-red-500 text-sm mt-1">{errors.WeightLimit}</div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Deduction Rate</label>
                <input
                  type="number"
                  name="DeductionRate"
                  value={formData.DeductionRate}
                  onChange={handleInputChange}
                  className="w-full border rounded p-2"
                  placeholder="Enter deduction rate"
                />
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                type="submit"
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Update Sub Category
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
